module.exports = __webpack_public_path__ + "static/media/BSSLoginLogopng.49f2b40f.png";